<script>
	import Portal from "svelte-portal"

	export let lang, dataset

	const svgBucket = 'localhost'
	const strings = lang == 'en' ? {
		"close": "Close",
		"headline": "Stay in the know with exclusive deals and event updates.",
		"placeholder": "Let's get started with an email",
		"button": "Sign Up",
		"failheading": "You're already on the list!",
		"fail": "This email is on our mailing list. You will receive an email to access your profile where you can make updates to your information at any time.",
		"invalid": "Email address is not valid",
	} : {
		"close": "Fermer",
		"headline": "Restez à l’affût des offres exclusives et des mises à jour d’événements.",
		"placeholder": "Commençons par un courriel",
		"button": "S’inscrire",
		"failheading": "Vous êtes déjà sur la liste!",
		"fail": "Cette adresse courriel est sur notre liste de diffusion. Vous recevrez un courriel pour accéder à votre profil où vous pourrez mettre à jour vos informations à tout moment.",
		"invalid": "Adresse de courriel invalide",
	}


	let email = ''
	let processing = false
	let formatError = false
	let emailFormatError = false

		
	async function signup() {
		
		// reset state
		processing = true
		formatError = false
		emailFormatError = false
		
		// trap no preferred store
		if (!localStorage.getItem('preferredStore')) {
			if (lang == "fr") {
				window.location.href = dataset.redirectionalterfr
				processing = false
				return false
			} else {
				window.location.href = dataset.redirectionalteren
				processing = false
				return false
			}
		}

		// validate the email
		if (!email.match("[a-z0-9A-Z._%+-]+@[a-z0-9A-Z.-]+\.[a-zA-Z]{2,4}$")) {
			formatError = true
			processing = false
			return false
		}
		
		// get preferred store's postal code
		var preferredStore = localStorage.getItem('preferredStore')
		var postalCode = JSON.parse(preferredStore||'{}')?.address?.postalOrZipCode || false
		
		// set timestamp for request
		var now = new Date()
		var timeStamp = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + (now.getDate()) + "-" + now.getHours() + ':' + ((now.getMinutes() < 10) ? ("0" + now.getMinutes()) : (now.getMinutes())) + ':' + ((now.getSeconds() < 10) ? ("0" + now.getSeconds()) : (now.getSeconds()))
		
		// send API request to Relation 1
		fetch(dataset.emaillink, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': dataset.btoken
			},
			body: JSON.stringify({
				EmailAddress: email,
				FirstName: ' ',
				PostalCode: postalCode,
				Preferred_Language: lang == 'fr' ? 'French' : 'English',
				Is_Contractor: 'No',
				Source: 'HH Website',
				ConsentType: 'explicit'
			}),
		})
		.then(res => res.json())
		.then(res => {

			// if new email
			if (res.IsNew === true) {
				
				// get token
				fetch(`${dataset.linkrelation1gettoken}?emailaddress=${email}&timeStamp=${timeStamp}`, {
					method: 'GET',
					mode: 'cors'
				})
				.then(res => res.text())
				.then(resToken => {
					
					// datalayer garbage
					try {
						window.dataLayer.push(function() {
							this.reset()
						})
						window.dataLayer.push({
							'event' : 'emailSignUp',
							'source' : 'website', 
							'location' : 'footer' 
						})
					}
					catch(e) {
						console.log("emailSignUp dataLayer object Failed: " + e)
						processing = false
					}

					// redirect to preferences page (using the recieved token)
					if (lang == "fr") {
						window.location.href = dataset.redirectionlinkfr + resToken
					} else {
						window.location.href = dataset.redirectionlinken + resToken
					}
				})
				.catch(err => {
					// handle error
					console.warn(err)
					emailFormatError = true
					processing = false
				})

			// if there is an error, display error message
			} else if (res.ErrorMessage) {
				console.warn(res.ErrorMessage)
				formatError = true
			
			// ...otherwise assume there is an issue with the email addy
			} else {
				emailFormatError = true
			}

			// release state
			processing = false
		})

	}

	async function signupNew() {
		try {
			// reset state
			processing = true
			formatError = false
			emailFormatError = false
			
			// trap no preferred store
			if (!localStorage.getItem('preferredStore')) {
				if (lang == "fr") {
					processing = false
					return false
				} else {
					processing = false
					return false
				}
			}
	
			// validate the email
			if (!email.match("[a-z0-9A-Z._%+-]+@[a-z0-9A-Z.-]+\.[a-zA-Z]{2,4}$")) {
				formatError = true
				processing = false
				return false
			}
			
			// get preferred store's postal code
			const preferredStore = localStorage.getItem('preferredStore')
			const postalCode = JSON.parse(preferredStore||'{}')?.address?.postalOrZipCode || false
	
			let sfmcApi = await fetch(`/_api/${lang}/sfmc/newCustomer`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					"autoSubscribe": true,
					"email": email,
					"existingCustomerEmailTemplate": "WelcomeBack",
					"values": {
						"postalcode" : postalCode,
						"preferred_language" : lang == 'fr' ? 'French' : 'English',
						"source" : 'HH Website',
						"consenttype" : 'explicit',
						//"is_contractor": "",
					}
				})
			})
			let sfmcResponse = await sfmcApi.text();
			let apitext = sfmcResponse
			try{
				sfmcResponse = JSON.parse(sfmcResponse)
				if(sfmcResponse?.wasExisitingCustomer) throw sfmcResponse
			} catch(error){
				if (error?.wasExisitingCustomer) {
					throw `Record already exists with email ${email}`
				}
				throw apitext
			} 

			// datalayer garbage
			try {
				window.dataLayer.push(function() {
					this.reset()
				})
				window.dataLayer.push({
					'event' : 'emailSignUp',
					'source' : 'website', 
					'location' : 'footer' 
				})
			}
			catch(e) {
				console.log("emailSignUp dataLayer object Failed: " + e)
				processing = false
			}

			let userCookie = getCookie('user')
			if(userCookie) {
				userCookie = JSON.parse(userCookie)
				if(userCookie && ["false", false].includes(userCookie.isAnonymous) && userCookie.email == email) {
					window.location.href = `/${lang}/landing/spa-my-account#/communication-preferences`
					return
				} 

			}
			let urlParams = new URLSearchParams()
			if(sfmcResponse?.values?.r1emi) {
				urlParams.append('r1emi', sfmcResponse?.values?.r1emi)
			} else {
				urlParams.append('h2eh', sfmcApi.headers.get('h2eh'))
			}
			window.location.href = `/${lang}/landing/communication-preferences?${urlParams.toString()}`



		} catch (error) {
			console.log(error)
			processing = false
			if(error == `Record already exists with email ${email}`) {
				emailFormatError = true
				window.dataLayer.push({
					'event' : 'emailSignUp',
					'source' : 'website', 
					'location' : 'footer' 
				})
			} else {
				formatError = true
			}
		}
	}
</script>



<h3 class="envelope">
	<!-- <img src="{svgBucket}/icon-email.svg" alt="Social" class="Icon" width="32.81px" height="24.61px" loading="lazy" /> -->
	<img src="https://homehardware.sirv.com/hh/svg/icon-email.svg" alt="Social" class="Icon" width="32.81px" height="24.61px" loading="lazy" />
	{strings.headline}
</h3>

<form on:submit|preventDefault={signupNew} id="">
	<input bind:value={email} type="email" required name="email" placeholder="{strings.placeholder}" />
	<button class="Button ButtonBlock ButtonNegative" type="submit" disabled={processing}>
		<span>{strings.button}</span>
		<img src="https://homehardware.sirv.com/hh/svg/hh-loader.white.svg" alt="loading animation">
	</button>
</form>

{#if emailFormatError}
<Portal target="hh-modal">
	<h3 class="Center"><img src="https://homehardware.sirv.com/hh/icons/icon-email-black.svg" alt="Social" class="Icon" width="32.81px" height="24.61px" loading="lazy" />{strings.failheading}</h3>
	<p class="Center">{strings.fail}</p>
	<div class="Center">
		<button class="Button ButtonSecondary" on:click={() => emailFormatError=false}>{strings.close}</button>
	</div>
</Portal>
{:else if formatError}
<Portal target="hh-modal" class="errorModal">
	<p>{strings.invalid}</p>
	<div class="Center">
		<button class="Button ButtonSecondary" on:click={() => formatError=false}>{strings.close}</button>
	</div>
</Portal>
{/if}

<style>
    :global(#hh-mfe-newsletter-form) {
		background: var(--hh-red);
		display: flex;
		justify-content: center;
		align-items: center;
		padding: calc(var(--gap) * 1);
		gap: calc(var(--gap) * 2);
    }
    :global(#hh-mfe-newsletter-form[data-decoupled]){
        margin-top: var(--gap);
    }
	h3.envelope {
		color: var(--hh-white);
		display: flex;
		align-items: center;
		gap: var(--gap);
	}
	.Icon {
		width: 1.25em !important;
		height: 1.25em !important;
	}
	.Icon:not(h3.envelope) {
		vertical-align: -25%;
	}
	form {
		display: grid;
		grid-template-columns: 3fr 1fr;
		grid-template-rows: 44px;
		gap: calc(var(--gap) / 1);
	}
	input[type="email"] {
		font: var(--fontsize)/160% "hhAgendaMedium", sans-serif;
		background-color: #fff;
		border: 0;
		border-radius: 30px;
		padding: 0 var(--gap);
	}
	input[type="email"]::placeholder {
		color: var(--hh-dark-grey);
		transition: color 0.15s;
	}
	input[type="email"]:focus::placeholder {
		color: transparent;
	}
	.ButtonBlock {
		margin: 0;
		white-space: nowrap;
		display: grid;
	}
	.ButtonBlock > * {
		grid-row: 1/-1;
		grid-column: 1/-1;
	}
	.ButtonBlock:disabled span {
		visibility: hidden;
	}
	.ButtonBlock:disabled {
		cursor: default;
	}
	.ButtonBlock:disabled:after {
		content: none;
	}
	.ButtonBlock img {
		width: 2em;
		justify-self: center;
		align-self: center;
	}
	.ButtonBlock:not(:disabled) img {
		visibility: hidden;
	}
	@media (max-width: 1200px) {
		:global(#hh-mfe-newsletter-form) {
			flex-direction: column;
			padding: calc(var(--gap) * 2);
			gap: calc(var(--gap) * 1);
		}
		h3.envelope {
			gap: calc(var(--gap) * 0.5);
			text-align: center;
		}
		form {
			grid-template-rows: auto;
			width: 75%;
		}
	}
	@media (max-width: 600px) {
		:global(#hh-mfe-newsletter-form) {
			flex-direction: column;
			padding: calc(var(--gap) * 2);
			gap: calc(var(--gap) * 1);
		}
		h3.envelope {
			flex-direction: column;
			gap: calc(var(--gap) * 0.5);
			text-align: center;
		}
		form {
			width: 100%;
			grid-template-columns: 1fr auto;
		}
	}
</style>
<!-- <pre>{email}</pre> -->